module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_microphone-43a3b6d73fd761a183167a003065c4d4.png";